export class DireccionI{
    id : BigInteger;
    fuente : BigInteger;
    tipovia : string;
    numvia : string;
    letravia : string;
    prefijo : string;
    cuaduno : string;
    numpreuno : string;
    letpre : string;
    numpredos : string;
    cuaddos : string;
    complemento : string;
    acomple : string;
}
